import create from 'zustand';

const stateDefault = {
  subMenu: [],
};

const actions = (set, get) => ({
  setSubMenu: (payload) => {
    console.log({ payload });
    set((state) => ({
      subMenu: payload,
    }));
  },
});

export const useSubmenu = create((set, get) => ({
  ...stateDefault,
  ...actions(set, get),
}));
